// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__tDSdF","header":"Skills_header__zx1yX","icons-container":"Skills_icons-container__gquKr","card":"Skills_card__2OoQ1"};